// import { useState } from 'react';
// import ConfirmationDialog from '../components/ConfirmationDialog'; 

// export function useConfirmation() {
//   const [confirmProps, setConfirmProps] = useState({
//     open: false,
//     title: '',
//     message: '',
//     onConfirm: () => {},
//     onCancel: () => {},   // Add this line
//   });

//   function confirm({ title, message }) {
//     return new Promise((resolve) => {
//       setConfirmProps({
//         open: true,
//         title,
//         message,
//         onConfirm: () => {
//           setConfirmProps((prev) => ({ ...prev, open: false }));
//           resolve(true);
//         },
//         onCancel: () => {
//           setConfirmProps((prev) => ({ ...prev, open: false }));
//           resolve(false);
//         },
//       });
//     });
//   }

//   const ConfirmationDialogComponent = (
//     <ConfirmationDialog
//       open={confirmProps.open}
//       title={confirmProps.title}
//       message={confirmProps.message}
//       onConfirm={confirmProps.onConfirm}
//       onCancel={confirmProps.onCancel}
//     />
//   );

//   return [confirm, ConfirmationDialogComponent];
// }

import { useState } from 'react';
import ConfirmationDialog from '../components/ConfirmationDialog'; 

export function useConfirmation() {
  const [confirmProps, setConfirmProps] = useState({
    open: false,
    title: '',
    message: '',
    onConfirm: () => {},
    onCancel: () => {},
  });

  function confirm({ title, message }) {
    return new Promise((resolve) => {
      setConfirmProps({
        open: true,
        title,
        message,
        onConfirm: () => {
          setConfirmProps((prev) => ({ ...prev, open: false }));
          resolve(true);
        },
        onCancel: () => {
          setConfirmProps((prev) => ({ ...prev, open: false }));
          resolve(false);
        },
      });
    });
  }

  // Make ConfirmationDialogComponent a React component function, not JSX
  function ConfirmationDialogComponent() {
    return (
      <ConfirmationDialog
        open={confirmProps.open}
        title={confirmProps.title}
        message={confirmProps.message}
        onConfirm={confirmProps.onConfirm}
        onCancel={confirmProps.onCancel}
      />
    );
  }

  return [confirm, ConfirmationDialogComponent];
}
